app.factory("SyllabusService", ["$http",
    function ($http) {
        var SyllabusService = {};

        SyllabusService.getBySubject = function (params) {
            return $http.get("/syllabuses/" + params.subjectId).then(function (resp) {
                return resp.data;
            })
        };

        SyllabusService.save = function (params) {
            return $http.post("/syllabuses/" + params.subjectId, params.syllabus).then(function (resp) {
                return resp.data
            })
        };

        SyllabusService.getReviewList = function () {
            return $http.post("/syllabuses/requests/toApprove", {}).then(function (resp) {
                return resp.data
            })
        };

        SyllabusService.approve = function (data) {
            return $http.post("/syllabuses/requests/approve", data).then(function (resp) {
                return resp.data
            })
        };

        return SyllabusService;
    }
]);
